// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aIcBo{display:flex;flex:1 1;flex-direction:column;gap:.5rem;min-height:0;overflow-y:auto;padding-bottom:.75rem;position:relative}.JMC9T{background-color:#85b7d914;border:1px solid #85b7d980;border-radius:.6rem;box-sizing:border-box;height:var(--command-palette-highlight-height,0);left:0;pointer-events:none;position:absolute;top:0;transform:translateY(var(--command-palette-highlight-y,0));transition:transform .2s ease,height .2s ease;width:100%;z-index:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listbox": `aIcBo`,
	"highlight": `JMC9T`
};
module.exports = ___CSS_LOADER_EXPORT___;
